<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('washroomFrequency.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog v-model="scelta" max-width="800" persistent>
            <v-card class="mb-4" width="100%" flat>
                <v-card-title>
                    {{ $t('washroomFrequency.selectSensor') }}
                </v-card-title>
                <v-card-text>
                    <v-layout class="mt-4" id="makeMeBlue">
                        <v-flex xs6 sm3 md3>
                            <v-select class="v-select" 
                                v-model="client" 
                                :items="clients" 
                                :label="$t('washroomFrequency.client')"
                                outlined
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex xs6 sm3 md3>
                            <v-select class="ml-2" 
                                v-model="building" 
                                :items="buildings" 
                                :label="$t('washroomFrequency.building')"
                                outlined 
                                :disabled="buildingActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex xs6 sm3 md3>
                            <v-select class="ml-2" 
                                v-model="floor" 
                                :items="floors" 
                                :label="$t('washroomFrequency.floor')" 
                                outlined
                                :disabled="floorActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex xs6 sm3 md3>
                            <v-select class="ml-2" 
                                v-model="area" 
                                :items="areas" 
                                :label="$t('washroomFrequency.area')"
                                outlined 
                                :disabled="areaActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex xs6 sm3 md3>
                            <v-select class="ml-2" 
                                v-model="sensorsValue" 
                                :items="sensor_items" 
                                :label="$t('washroomFrequency.sensor')" 
                                outlined
                                :key="s" 
                                :disabled="sensorActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="#213A8F" @click="goBack">{{ $t('washroomFrequency.back') }}</v-btn>
                    <v-btn text color="#213A8F" :disabled="okActive" @click="LoadData()">{{ $t('washroomFrequency.ok') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card class="mb-4" width="100%" flat v-show="!scelta">
            <v-card-text>
                <v-layout class="mt-4" id="changeMyColor">
                    <v-flex xs6 sm3 md3>
                        <v-select class="v-select" 
                            v-model="client" 
                            :items="clients" 
                            :label="$t('washroomFrequency.client')"
                            outlined
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="building" 
                            :items="buildings" 
                            :label="$t('washroomFrequency.building')" 
                            outlined 
                            :key="b"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="floor" 
                            :items="floors" 
                            :label="$t('washroomFrequency.floor')" 
                            outlined 
                            :key="f"
                            :disabled="floorActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="area" 
                            :items="areas" 
                            :label="$t('washroomFrequency.area')"
                            outlined 
                            :disabled="areaActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="sensorsValue" 
                            :items="sensor_items" 
                            :label="$t('washroomFrequency.sensor')" 
                            outlined
                            :key="s" 
                            :disabled="sensorActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3 class="ml-2">
                        <v-menu ref="menu" 
                            v-model="menu" 
                            :close-on-content-click="false" 
                            :return-value.sync="date"
                            transition="scale-transition" 
                            offset-y 
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field outlined 
                                    v-model="date" 
                                    :label="$t('washroomFrequency.selectDateRange')"
                                    prepend-inner-icon="mdi-calendar" 
                                    readonly 
                                    v-bind="attrs" 
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="date" 
                                no-title 
                                scrollable 
                                :locale="$i18n.locale" 
                                range 
                                :max="maxDate"
                                :min="minDate" 
                                @click="SetMinDate">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">
                                    {{ $t('washroomFrequency.cancel') }}
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(date); GetDataByDate()">
                                    {{ $t('washroomFrequency.ok') }}
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card width="100%" flat v-show="!scelta">
            <v-card-text>
                
                <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
                <v-layout v-show="visualizza_dati && !scelta">
                    <v-flex xs6 sm6 md3 class="mt-6 mb-4 mr-4 ml-4 justify-left">
                        <h2 style="font-weight: bold;">{{ $t('washroomFrequency.quickFilters') }} </h2>
                    </v-flex>
                    <v-flex xs6 sm6 md3>
                        <v-btn text @click="ChangeDate('4h')" class="mt-4 mb-4 mr-4 ml-4">
                            <h2 :style="'color: ' + colore4h">| {{ $t('washroomFrequency.hours') }} |</h2>
                        </v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md3>
                        <v-btn text @click="ChangeDate('1')" class="mt-4 mb-4 mr-4 ml-4">
                            <h2 :style="'color: ' + colore1d">| {{ $t('washroomFrequency.day') }} |</h2>
                        </v-btn>
                    </v-flex>
                    <!-- <v-flex xs6 sm6 md3>
                  <v-btn text @click="ChangeDate('3')"  class="mt-4 mb-4 mr-4 ml-4"><h2 :style="'color: ' + colore3d">| 3 DAYS |</h2></v-btn>
              </v-flex> -->
                    <v-flex xs6 sm6 md3>
                        <v-btn text @click="ChangeDate('7')" class="mt-4 mb-4 mr-4 ml-4">
                            <h2 :style="'color: ' + colore1w">| {{ $t('washroomFrequency.week') }} |</h2>
                        </v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md3>
                        <v-btn text @click="ChangeDate('14')" class="mt-4 mb-4 mr-4 ml-4">
                            <h2 :style="'color: ' + colore2w">| {{ $t('washroomFrequency.twoWeeks') }} |</h2>
                        </v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md3>
                        <v-btn text @click="ChangeDate('30')" class="mt-4 mb-4 mr-4 ml-4">
                            <h2 :style="'color: ' + colore3d">| {{ $t('washroomFrequency.thirtyDays') }} |</h2>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <hr style="border-top: solid 1px; color: #BFCCE4" />
        <h2 class="mt-4">{{ sensor_name }}</h2>
        <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
        <v-card class="mt-4" height="100%" flat v-show="visualizza_dati && !scelta">
            <v-card-text>

                <v-layout class="mt-4 mr-4 mb-4 ml-4">
                    <v-flex xs12 sm12 md6>
                        <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                            <h2 class="mb-2">{{ $t('washroomFrequency.dataManager') }}</h2>
                            <v-layout>
                                <v-flex sm6 md6>
                                    <h3 class="text-center mt-8">{{ $t('washroomFrequency.sensorName') }}</h3>
                                    <p class="text-center">{{ sensor_name }}</p>
                                    <img class="mt-2 mr-4 align-center" style="align-content:center" :src="sensor_img"
                                        width="50%" />

                                </v-flex>

                                <v-flex sm12 md12>
                                    <v-card-text class="text-center">

                                        <h3 class="mt-4">{{ $t('washroomFrequency.building') }}:</h3> {{ building_name }}
                                        <h3 class="mt-12">{{ $t('washroomFrequency.floor') }}: </h3> {{ floor_name }}


                                    </v-card-text>
                                </v-flex>

                            </v-layout>
                            <h3 v-if="$store.state.company == '1'" class="mt-16 ">{{ $t('washroomFrequency.cleaningSchedule') }}<v-icon @click="DownloadSchedule()"
                                    color="#234a98">mdi-download</v-icon></h3>
                            <v-card-text class="align-center justify-center">
                                <!-- <h3>CLEANING SCHEDULE<v-icon @click="DownloadSchedule()" color="#234a98">mdi-download</v-icon></h3> -->
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <div style="border-left: 1px solid #BFCCE4; height: 350px;" class="mt-4"></div>
                    <v-flex xs12 sm12 md6>
                        <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                            <h2 class="align-center justify-center mb-2" style="color: #213A8F !important">{{ $t('washroomFrequency.washroomUsageFrequency') }} </h2>
                            <v-card-text class="justify-center">
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="justify-center mt-8">
                                        <!-- <apexchartComponent type="radialBar" height="350" :options="PunctualchartOptions" :series="series_punctual" :key="radialKey"></apexchartComponent> -->
                                        <apexchartComponent type="bar" height="50" :options="PunctualchartOptions"
                                            :series="series_punctual"></apexchartComponent>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="text-left mt-2">
                                        <div class="mt-4">
                                            <h3>{{ $t('washroomFrequency.lastCleaning') }} </h3>
                                            <h4 style=" font-weight: normal;">{{ last_managed }}</h4>
                                        </div>
                                        <v-layout class="mt-8">
                                            <v-flex xs12 sm6 md6>
                                                <div>
                                                    <h3>{{ $t('washroomFrequency.cleaningStatus') }} </h3>  
                                                    <h4 style=" font-weight: normal;"><v-icon
                                                            :color="colore_stato">mdi-circle</v-icon>
                                                        {{ getCleaningStateLabel() }}</h4>
                                                </div>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6>
                                                <div>
                                                    <h3>{{ $t('washroomFrequency.alertThreshold') }} </h3>
                                                    <h4 style=" font-weight: normal;">{{ alert_threshold }} {{ $t('washroomFrequency.events') }}</h4>
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                        <!-- <div class="mt-8"><h3 style="display: inline-block;">Time: </h3> <h4 style="display: inline-block; font-weight: normal;"> {{ OraSensore }}</h4></div> -->
                                    </v-flex>
                                </v-layout>

                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
                <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
              <v-flex xs12 sm12 md12>
                      <v-card class="mt-4 mr-4 mb-4 ml-4" height="100%" flat>
                          <v-card-title> -->
                <!-- <v-layout> -->
                <!-- <v-flex xs12 sm12 md3>
                                  <v-select
                                  v-model="displayed_range"
                                  :items="to_display"
                                  label="Select displayed range"
                                  >
                                  </v-select>
                              </v-flex> -->
                <!-- <v-flex xs12 sm12 md12>
                              
                          </v-flex>
                          </v-layout>
                          </v-card-title>
                          <v-card-text>
                              <h2 style="margin-top: 15px; font-weight: bold;  color: #234a98 !important" >BIN LEVEL </h2>
                              <apexchartComponent type="line" height="350" :options="chartOptions_bin" :series="series_dispenser" />
                          </v-card-text>
                          <v-card-actions>
  
                          </v-card-actions>
                      </v-card>
                      </v-flex>
                  
              </v-layout> -->
                <!-- <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4"/> -->
                <v-layout class="mt-4 mr-4 mb-4 ml-4">
                    <v-flex xs12 sm12 md12>
                        <v-card class="mt-4 mr-4 mb-4 ml-4" height="100%" flat>
                            <h2>{{ $t('washroomFrequency.washroomUsageFrequency') }}</h2>
                            <v-card-text>
                                <apexchartComponent type="bar" height="350" :options="chartOptions_bin"
                                    :series="series_dispenser" :key="keyStacked" />
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <!-- <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4"/> -->
                <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
                      <v-flex xs12 sm12 md12>
                      <v-card class="mt-4 mr-4 mb-4 ml-4" height="100%" flat>
                          <v-card-text>
                              <h2 style="margin-top: 15px; font-weight: bold; color: #234a98 !important" >FULL HOUR(S) </h2>
                              <apexchartComponent max-width="20%" type="bar" height="350" :options="chartOptions_bar" :series="series_bar" :key="keyBar" />
                          </v-card-text>
                      </v-card>
                      </v-flex>
                  </v-layout> -->

            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";
export default {
    name: 'SmartBinView',
    data() {
        return {
            maxDate: "",
            minDate: "",
            cleaning_state: '',
            last_managed: '',
            alert_threshold: '',
            dayli: 0,
            scelta: true,
            visualizza_dati: false,
            sensor_img: "",
            sensorActive: true,
            floorActive: true,
            i: 0,
            b: 0,
            s: 0,
            f: 0,
            colore4h: "#DAE0EC",
            index4h: 0,
            colore1d: "#DAE0EC",
            colore3d: "#DAE0EC",
            colore1w: "#DAE0EC",
            colore2w: "#DAE0EC",
            colore_stato: "",
            overlay: false,
            building_name: "",
            floor_name: "",
            level_status: 0,
            last_refill: "2023-02-01",
            GiornoSettimana: '',
            OraSensore: '',
            DataSensore: '',
            keyBar: 0,
            keyStacked: 0,
            radialKey: 0,
            sensor_name: "",
            colors: "#18ff00",
            series_punctual: [],
            PunctualchartOptions: {
                colors: [
                    "#009CAB",
                    "#dae0ec",
                ],
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                chart: {
                    type: 'bar',
                    stacked: true,
                    //stackType: "100%",
                    offsetY: -20,
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, { seriesIndex, dataPointIndex, w }) {
                        dataPointIndex;
                        if (w.config.series[seriesIndex].name != 'Empty')
                            return val
                        else
                            return ''
                    },
                },
                xaxis: {

                    min: 0,
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                        },
                    },
                    axisTicks: {
                        colors: '#BFCCE4',
                    },
                },
                plotOptions: {
                    states: {
                        hover: {
                            filter: {
                                type: 'none',
                                value: 0,
                            }
                        }
                    },
                    bar: {
                        borderRadius: 4,
                        columnWidth: '100%',
                        horizontal: true,
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 5, // margin is in pixels
                            dropShadow: {
                                enabled: true,
                                top: 2,
                                left: 0,
                                color: '#999',
                                opacity: 1,
                                blur: 2
                            }
                        },
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        inverseColors: true,
                        gradientToColors: ['#213A8F'],
                        gradientFromColors: ['#009CAB'],
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    },
                },
            },



            handPaperRolls: 0,
            foldedTowels: 0,
            users: 0,
            averageUsers: 0,
            menu: false,
            date: [],
            floor_items: [],
            floorValue: "",
            buildingValue: [],
            lista_bin: [],
            lista_stacked: [],
            valueBin: [],
            valueStacked: [],
            valueBar: [],
            valueVuoto: [],
            valueRotoli: [],
            valueDispenser: [],
            dialogBar: false,
            dialogBin: false,
            dialogStacked: false,
            dialogVuoto: false,
            dialogRotoli: false,
            dialogDispenser: false,
            building_items: [],
            series_bin: [],
            series_stacked: [],
            series_bar: [],
            series_dispenser: [],
            series_rotoli: [],
            series_vuoto: [],
            sensor_unique: '',
            chartOptions_bin: {
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                colors: ['#BFCCE4'],
                dropShadow: {
                    enabled: false,
                    enabledOnSeries: undefined,
                    top: 0,
                    left: 0,
                    blur: 3,
                    color: '#000',
                    opacity: 0.35
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'line',
                    height: 700,
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        show: false,
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                yaxis: {
                    min: 0,


                    labels: {
                        offset: 10,
                        style: {
                            colors: '#BFCCE4',
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        },
                    }
                },
                xaxis: {
                    colors: '#213A8F',
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: false,
                    position: 'right',
                    offsetX: 0,
                    offsetY: 50
                },
            },

            chartOptions_stacked: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                colors: ['#008ffb'],
                chart: {

                    toolbar: {
                        show: false,
                    },
                    type: 'bar',
                    height: 350,
                    // stacked: true,
                    // stackType: '100%'
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                xaxis: {
                    categories: ['01/09/2022', '02/09/2022', '03/09/2022', '04/09/2022', '05/09/2022', '06/09/2022',
                        '07/09/2022', '08/09/2022'
                    ],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    colors: ['#BFCCE4'],
                    opacity: 1
                },
                legend: {
                    show: false,
                },
                title: {
                    text: "",
                    rotate: -90,
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title',
                    },
                }
            },
            crosshairs: {
            },
            chartOptions_bar: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    colors: ['#BFCCE4']
                },
                stroke: {
                    curve: 'straight'
                },
                legend: {
                    show: false,
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                            legend: {
                                show: false,
                            },
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                        },
                    },
                },
                colors: '#BFCCE4',
            },
            sensor_id: "",
            sensor_items: [],
            sensorsValue: "",
            okActive: true,
            minValue: 0,
            maxValue: 0,
            client: "",
            clients: [],
            buildingActive: true,
            areaActive: true,
            building: "",
            buildings: [],
            floor: "",
            floors: [],
            area: "",
            areas: [],
        }
    },

    watch: {
        client(value) {
            if (value != undefined && value != null && value != "" && value != 0) {
                this.buildingActive = false;
                this.buildings.length = 0;
                this.buildingValue = '';
                this.buildings = [];
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                this.building_name = '';
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.BuildingName, value: el.id }
                        this.buildings.push(element);
                    });
                })
            } else {
                this.buildingActive = true;
                this.buildings.length = 0;
                this.buildingValue = '';
                this.buildings = [];
                this.building_name = '';
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
            }
        },
        building(value) {
            if (value != undefined && value != null && value != "" && value != 0) {
                this.floorActive = false;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                
                const selectedOption = this.buildings.find(option => option.value === value);
                if (selectedOption) {
                    this.building_name = selectedOption.text;
                }
                
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.FloorName, value: el.id }
                        this.floors.push(element);
                    });
                })
            } else {
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                this.building_name = '';
            }
        },
        floor: {
            handler(value) {
                if (value && value !== "") {
                    this.areaActive = false;
                    this.areas.length = 0;
                    this.area = '';
                    this.areas = [];
                    this.sensorActive = true;
                    this.sensor_items.length = 0;
                    this.sensorsValue = '';
                    this.sensor_items = [];
                    
                    const selectedOption = this.floors.find(option => option.value === value);
                    if (selectedOption) {
                        this.floor_name = selectedOption.text;
                    }
                    
                    axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: value
                    })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);
                        });
                    });
                } else {
                    this.floorActive = true;
                    this.floors.length = 0;
                    this.floor = '';
                    this.floors = [];
                    this.floor_name = '';
                    this.areaActive = true;
                    this.areas.length = 0;
                    this.area = '';
                    this.areas = [];
                    this.sensorActive = true;
                    this.sensor_items.length = 0;
                    this.sensorsValue = '';
                    this.sensor_items = [];
                }
            },
            immediate: true
        },
        area(value) {
            if (value != undefined && value != null && value != "" && value != 0) {
                this.sensor_items.length = 0;
                this.sensor_items = [];
                this.sensorsValue = "";
                this.sensorActive = false;
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.client,
                    buildingId: this.building,
                    floorId: this.floor,
                    areaId: value,
                    type: "Washroom"

                })
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.DisplayName, value: el }
                        this.sensor_items.push(element);
                    });
                })
            } else {
                this.sensor_items.length = 0;
                this.sensor_items = [];
                this.sensorsValue = "";
            }
        },
        sensorsValue(value) {
            if (value) {
                this.sensor_name = value.DisplayName;
                this.sensor_img = value.DispenserImage;
                this.sensor_unique = value.DispenserUnique;
                this.sensor_id = value.DispenserId;
                this.okActive = false;
                this.LoadData();
            }
        }
    },
    created() {
        if (this.$store.state.company) {
            this.overlay = true;
            this.DownloadCompanyDatas();
        }
    },
    mounted() {
        //this.overlay = true;


        // this.GetDataStacked(7);
        // // this.buildingValue = this.building_items[0];
        // // this.b ++;
        // this.date.push(new Date().toISOString().toString().substr(0,10));
        // this.GetData(new Date().toISOString().toString().substr(0,10),new Date(),0)
        // this.date.push(new Date().toISOString().toString().substr(0,10));
        // this.GetSensorData(this.subtractDays(-4, new Date()).toISOString().toString().substr(0,10), this.subtractDays(1, new Date()).toISOString().toString().substr(0,10));
    },
    methods: {
        getCleaningStateLabel() {
            switch (this.cleaning_state) {
                case 'Cleaning Required':
                    return this.$t('washroomFrequency.cleaningRequired');
                case 'Might need clean':
                    return this.$t('washroomFrequency.mightNeedClean');
                case "Doesn't need clean":
                    return this.$t('washroomFrequency.doesntNeedClean');
                default:
                    return this.cleaning_state;
            }
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        SetMinDate() {
            this.maxDate = new Date(this.date.start.getTime() + 15 * 24 * 60 * 60 * 1000);
        },
        GetDataByDate() {
            this.overlay = true;
            this.GetSensorData(this.subtractDays(0, new Date(this.date[0])).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date(this.date[1])).toISOString().toString().substr(0, 10));
        },
        DownloadSchedule() {
            axios.post(this.$store.state.URL_GETSCHEDULEDATA, {
                "sensor": this.sensor_id
            })
                .then(res => {
                    var csv = "SENSOR NAME;BUILDING;FLOOR;CLEANING DATE;CLEANING HOUR;CLEANER\n";
                    res.data.map(el => {
                        csv += el.DeviceName + ";"
                        csv += this.building_name + ";"
                        csv += this.floor_name + ";"
                        csv += el.Timestamp_Gestione.split(" ")[0] != "0000-00-00" ? el.Timestamp_Gestione.split(" ")[0] + ";" : "--" + ";"
                        csv += el.Timestamp_Gestione.split(" ")[1] != "00:00:00" ? el.Timestamp_Gestione.split(" ")[1] + ";" : "--" + ";"
                        csv += el.User + "\n"

                    })

                    let csvContent = "data:text/csv;charset=utf-8," + csv;
                    var encodedUri = encodeURI(csvContent);
                    const link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", "cleaning_schedule.csv");
                    link.click();

                }
                )
        },
        async DownloadCompanyDatas() {
            try {
                // Carica i clienti
                const clientsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
                this.clients = clientsResponse.data.map(el => ({ text: el.CompanyName, value: el.id }));
                
                // Se ci sono parametri nella route, carica i dati del sensore
                if (this.$route.params) {
                    const { company, building, floor, area, sensorId } = this.$route.params;
                    
                    // Imposta il cliente
                    this.client = company;
                    
                    // Carica gli edifici
                    const buildingsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                        companyId: company
                    });
                    this.buildings = buildingsResponse.data.map(el => ({ text: el.BuildingName, value: el.id }));
                    
                    // Imposta l'edificio e carica i piani
                    this.building = building;
                    const floorsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                        buildingId: building
                    });
                    this.floors = floorsResponse.data.map(el => ({ text: el.FloorName, value: el.id }));
                    
                    // Imposta il piano e carica le aree
                    this.floor = floor;
                    const areasResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: floor
                    });
                    this.areas = areasResponse.data.map(el => ({ text: el.AreaName, value: el.id }));
                    
                    // Imposta l'area e carica i sensori
                    this.area = area;
                    const sensorsResponse = await axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                        companyId: company,
                        buildingId: building,
                        floorId: floor,
                        areaId: area,
                        type: "Washroom"
                    });
                    
                    this.sensor_items = sensorsResponse.data.map(el => ({ text: el.DisplayName, value: el }));
                    
                    // Trova e imposta il sensore corretto
                    const sensor = sensorsResponse.data.find(s => s.DispenserId === sensorId);
                    if (sensor) {
                        this.sensorsValue = { text: sensor.DisplayName, value: sensor };
                        this.sensor_name = sensor.DisplayName;
                        this.sensor_img = sensor.DispenserImage;
                        this.sensor_unique = sensor.DispenserUnique;
                        this.sensor_id = sensor.DispenserId;
                        this.scelta = false;
                        await this.LoadData();
                    }
                }
            } catch (error) {
                console.error('Errore nel caricamento dei dati:', error);
                this.overlay = false;
            }
        },
        LoadData() {
            this.overlay = true;
            this.scelta = false;
            axios.
                post(this.$store.state.URL_LASTMANAGED, {
                    "sensor": this.sensor_id
                })
                .then(res => {
                    console.log(res.data);
                    this.last_managed = res.data[0]?.Timestamp_Gestione;
                    this.alert_threshold = res.data[0]?.AlertValue;
                    var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                    punctual_value = punctual_value < 0 ? 0 : punctual_value;
                    var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                    if (perc > 60) {
                        this.colore_stato = "red";
                        this.cleaning_state = "Cleaning Required";
                    }
                    if (perc >= 20 && perc <= 60) {
                        this.colore_stato = "#ffac27";
                        this.cleaning_state = "Might need clean";
                    }
                    if (perc < 20) {
                        this.colore_stato = "green";
                        this.cleaning_state = "Doesn't need clean";
                    }
                    this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                    console.log("Valore: " + punctual_value.toString())
                    this.radialKey += 1;
                    //this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
                    //this.chartOptions_bin.plotOptions.bar.columnWidth = "15%"
                    this.GetDataStacked(1);
                    this.date.push(new Date().toISOString().toString().substr(0, 10));
                    //this.GetData(new Date().toISOString().toString().substr(0,10),new Date(),0)
                    this.date.push(new Date().toISOString().toString().substr(0, 10));
                    this.GetSensorData(this.subtractHours(4, new Date()).toISOString().toString().substr(0, 19), new Date().toISOString().toString().substr(0, 19), 1);
                })



        },
        ChangeDate(period) {
            this.overlay = true;
            switch (period) {
                case "4h":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetSensorData(this.subtractHours(4, new Date()).toISOString().toString().substr(0, 19), new Date().toISOString().toString().substr(0, 19), 1);
                            this.GetDataStacked(1);
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "15%"
                            this.colore4h = "#213A8F"
                            this.colore1d = "#DAE0EC"
                            this.colore3d = "#DAE0EC"
                            this.colore1w = "#DAE0EC"
                            this.colore2w = "#DAE0EC"
                        })
                    break;
                case "1":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetSensorData(this.subtractDays(0, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), 1);
                            this.GetDataStacked(1);
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "15%"
                            this.colore4h = "#DAE0EC"
                            this.colore1d = "#213A8F"
                            this.colore3d = "#DAE0EC"
                            this.colore1w = "#DAE0EC"
                            this.colore2w = "#DAE0EC"
                        })
                    break;
                case "3":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetDataStacked(3);
                            this.GetSensorData(this.subtractDays(-2, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10));
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "40%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "40%"
                            this.colore3d = "#213A8F";
                            this.colore4h = "#DAE0EC"
                            this.colore1d = "#DAE0EC"
                            this.colore1w = "#DAE0EC"
                            this.colore2w = "#DAE0EC"
                        })
                    break;
                case "7":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetDataStacked(7);
                            this.GetSensorData(this.subtractDays(-6, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10));
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "55%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "55%"
                            this.colore1w = "#213A8F";
                            this.colore3d = "#DAE0EC";
                            this.colore4h = "#DAE0EC"
                            this.colore1d = "#DAE0EC"
                            this.colore2w = "#DAE0EC"
                        })
                    break;
                case "14":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetDataStacked(14);
                            this.GetSensorData(this.subtractDays(-13, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10));
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "70%"
                            this.colore2w = "#213A8F";
                            this.colore1w = "#DAE0EC";
                            this.colore3d = "#DAE0EC";
                            this.colore4h = "#DAE0EC"
                            this.colore1d = "#DAE0EC"
                        })
                    break;
                case "30":
                    axios.
                        post(this.$store.state.URL_LASTMANAGED, {
                            "sensor": this.sensor_id
                        })
                        .then(res => {
                            console.log(res.data);
                            this.last_managed = res.data[0]?.Timestamp_Gestione;
                            this.alert_threshold = res.data[0]?.AlertValue;
                            var punctual_value = Number(res.data[0]?.AlertValue) - Number(res.data[0]?.PartialCount);
                            punctual_value = punctual_value < 0 ? 0 : punctual_value;
                            var perc = (Number(res.data[0]?.PartialCount * 100)) / Number(res.data[0]?.AlertValue);
                            if (perc > 60) {
                                this.colore_stato = "red";
                                this.cleaning_state = "Cleaning Required";
                            }
                            if (perc >= 20 && perc <= 60) {
                                this.colore_stato = "#ffac27";
                                this.cleaning_state = "Might need clean";
                            }
                            if (perc < 20) {
                                this.colore_stato = "green";
                                this.cleaning_state = "Doesn't need clean";
                            }
                            this.series_punctual = [{ name: "Event to the alert", data: [punctual_value] }, { name: "Event triggered", data: [Number(res.data[0].PartialCount)] }];
                            console.log("Valore: " + punctual_value.toString())
                            this.radialKey += 1;
                            this.GetDataStacked(30);
                            this.GetSensorData(this.subtractDays(-29, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10));
                            this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
                            this.chartOptions_bin.plotOptions.bar.columnWidth = "70%"
                            this.colore2w = "#DAE0EC";
                            this.colore1w = "#DAE0EC";
                            this.colore3d = "#213A8F";
                            this.colore4h = "#DAE0EC"
                            this.colore1d = "#DAE0EC"
                        })
                    break;
            }
        },
        subtractHours(numOfHours, date = new Date()) {
            date.setHours(date.getHours() - numOfHours + 1);
            return date;
        },
        subtractDays(numOfDays, date = new Date()) {
            date.setDate(date.getDate() + numOfDays);

            return date;
        },
        GetSensorData(start, nextDay, time = 0, skip = 0) {

            start = start.length == 10 ? start + " 00:00:00" : start.replace("T", " ");
            nextDay = nextDay.length == 10 ? nextDay + " 00:00:00" : nextDay.replace("T", " ");
            axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO,
                {
                    "sensor_id": this.sensor_unique,
                    "from": start,
                    "to": nextDay
                }
            )
                .then(res => {
                    if (res.data.length == 0) {
                        this.series_dispenser.length = 0;
                        this.chartOptions_bin.xaxis.categories.length = 0;
                        this.overlay = false;
                        this.visualizza_dati = true;
                        this.keyStacked++;
                        return
                    }
                    console.log(skip);
                    this.series_dispenser.length = 0;
                    this.sensor_datas = res.data.Items;
                    this.loading = false;
                    this.series_bin.length = 0;
                    this.chartOptions_bin.xaxis.categories.length = 0;
                    var data_ = [];
                    var dati = [];

                    for (var i = res.data.length - 1; i >= 0; i--) {
                        if (res.data[i].device_data.received_at != undefined && res.data[i].device_data.doorCount != undefined)
                            dati.push(res.data[i].device_data);
                    }
                    //var j = 0;
                    console.log(time);
                    i = 0;
                    dati = dati.sort((a, b) => (a.received_at > b.received_at) ? 1 : -1)
                    console.log(dati);
                    //Recupero i valori per i punctual data
                    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                    const d = new Date();
                    let day = weekday[d.getDay()];
                    this.GiornoSettimana = day;
                    this.OraSensore = dati[dati.length - 1].received_at.substr(11, 5);
                    this.DataSensore = dati[dati.length - 1].received_at.substr(0, 10);
                    //var valore = 100-(((Number(dati[dati.length-1].doorCount.value) - this.minValue)* 100)/(this.maxValue - this.minValue)).toFixed(0);
                    // this.series_stacked.length = 0;
                    let valore_temp = 0;
                    var temp = dati[0].received_at.substr(0, 10);
                    var last = dati[dati.length - 1];
                    this.dayli = 0

                    if (time == 0) {
                        // Aggregazione per giornata (3 giorni, 1 settimana, 2 settimane, 30 giorni)
                        dati.forEach(el => {
                            var valore = el.doorCount.value;
                            if (valore == undefined)
                                valore = 0;
                            if (valore < 0)
                                valore = 0;
                            if (valore > 100)
                                valore = 100;
                            
                            var currentDay = el.received_at.substr(0, 10);
                            
                            // Se è lo stesso giorno, accumula
                            if (currentDay == temp) {
                                valore_temp += valore;
                            } else {
                                // Nuovo giorno: salva i dati del giorno precedente
                                if (valore_temp > 0 || this.chartOptions_bin.xaxis.categories.length > 0 || el != dati[0]) {
                                    this.chartOptions_bin.xaxis.categories.push(temp);
                                    data_.push(valore_temp);
                                }
                                temp = currentDay;
                                valore_temp = valore;
                            }
                            
                            // Se è l'ultimo elemento, aggiungi i dati accumulati
                            if (el == last) {
                                this.chartOptions_bin.xaxis.categories.push(temp);
                                data_.push(valore_temp);
                            }
                        })
                    }
                    else {
                        // Aggregazione per ora (4 ore o 1 giorno) - senza minuti e secondi
                        temp = dati[0].received_at.substr(0, 10) + " " + dati[0].received_at.substr(11, 2); // Data + ora
                        dati.forEach(el => {
                            var valore = el.doorCount.value;
                            if (valore == undefined)
                                valore = 0;
                            if (valore < 0)
                                valore = 0;
                            if (valore > 100)
                                valore = 100;
                            
                            var currentHour = el.received_at.substr(0, 10) + " " + el.received_at.substr(11, 2);
                            
                            // Se è la stessa ora, accumula
                            if (currentHour == temp) {
                                valore_temp += valore;
                            } else {
                                // Nuova ora: salva i dati dell'ora precedente
                                if (valore_temp > 0 || this.chartOptions_bin.xaxis.categories.length > 0 || el != dati[0]) {
                                    this.chartOptions_bin.xaxis.categories.push(temp.substr(0, 10) + " " + temp.substr(11, 2) + ":00");
                                    data_.push(valore_temp);
                                    this.dayli += valore_temp;
                                }
                                temp = currentHour;
                                valore_temp = valore;
                            }
                            
                            // Se è l'ultimo elemento, aggiungi i dati accumulati
                            if (el == last) {
                                this.chartOptions_bin.xaxis.categories.push(temp.substr(0, 10) + " " + temp.substr(11, 2) + ":00");
                                data_.push(valore_temp);
                                this.dayli += valore_temp;
                            }
                        })
                    }

                    //   if(time == 0){
                    //     if(dati.length > 50){
                    //         if(j==15 ){
                    //             this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //         }
                    //         else{
                    //             this.chartOptions_bin.xaxis.categories.push("");
                    //             j++;
                    //         }
                    //         }
                    //     else{
                    //         this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //     }
                    //   }
                    // if(time == 1){
                    //     if(dati.length > 30){
                    //         if(j==3){
                    //             this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //         }
                    //         else{
                    //             this.chartOptions_bin.xaxis.categories.push("");
                    //             j++;
                    //         }
                    //     }
                    //     else{
                    //         this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //     }
                    // }
                    this.series_dispenser.push({ data: data_, name: this.sensor_name });
                    console.log(this.series_dispenser)
                    this.overlay = false;
                    this.visualizza_dati = true;
                })
                .catch(() => {
                    this.loading = false;
                    this.overlay = false;
                })
        },
        GetDataStacked(days) {
            axios.post(this.$store.state.URL_STACKED, {
                sensor: this.sensor_unique,
                ndays: days
            }).
                then(res => {
                    this.chartOptions_stacked.xaxis.categories.length = 0;
                    this.series_stacked.length = 0;
                    this.series_bar.length = 0;
                    var elementi_vuoto = [];
                    var elementi_pieno = [];
                    var ore_vuoto = [];
                    var categories = [];
                    var v_med = [];
                    res.data.forEach(el => {
                        elementi_vuoto.push(el.Vuoto);
                        elementi_pieno.push(el.Pieno);
                        categories.push(el.DataRegistrazione);
                        ore_vuoto.push(el.OreVuoto);
                        v_med.push(el.Media);

                    })
                    this.series_bar = [{ name: "Full", data: ore_vuoto }];
                    this.series_stacked = [{ name: "Media valore", data: v_med }];
                    this.chartOptions_stacked.xaxis.categories = categories;
                    this.chartOptions_bar.xaxis.categories = categories;
                    this.keyStacked += 1
                    this.keyBar += 1
                })

                .catch(err => {
                    console.log(err);
                })
        }

    },
}
</script>
<style scoped>
.miochart.apexcharts-bar-area:hover {
    fill: #213A8F !important;
}

.apexcharts-line-area:hover {
    fill: #213A8F !important;
}

.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
    color: #213A8F !important;
}

.v-icon.v-incon {
    color: #213A8F !important;
}

#changeMyColor .v-text-field--outlined fieldset {
    border: #BFCCE4 1px solid !important;
}

.mt-4 mb-4 mr-4 ml-4 v-btn v-btn--text theme--light v-size--default {
    border: #213A8F 1px solid !important;
}
</style>